<template>
    <div>
        <div class="col-12" v-if="filter.title">
            <p class="filter__label group__label">{{ filter.title }}</p>
        </div>
        <div class="filter__group col-12">
            <template v-for="option in filter.options">
                <button @click="select(option, isActive(option.value) === 'inactive')" class="filter filter--secondary" :class="[isActive(option.value)]" :disabled="isActive(option.value) === 'inactive'">
                    <template v-if="option.title">
                        <span v-html="option.title" />
                    </template>
                    <template v-else>
						<span v-html="option.value" />
                    </template>
                </button>
            </template>
        </div>
    </div>
</template>

<script>
    import { constants } from "@productfinder/shared/constants";

    export default {
        name: "sal-filter-button",
        props: {
            filter: {}
        },
        computed: {
            selectedFilters() {
                return this.$store.getters.selectedFilters[this.filter.name]
            },
            constants() {
                return constants;
            }
        },
        methods: {
            select(option, disabled) {
                let value = option.value;
                if (value !== '') {
                    if (disabled) {
                        return;
                    }

                    if (this.selectedFilters && this.selectedFilters.some(element => { return value === element })) {
                        this.$store.dispatch('removeFilterState', { filterName: this.filter.name, value: value })
                    } else {
                        this.$store.dispatch('setFilterState', { filterName: this.filter.name, value: value })
                    }
                } else {
                    this.$store.dispatch('removeFilterState', { filterName: this.filter.name, value: null });
                }
            },
            isActive(value) {
                if (this.selectedFilters) {
                    if(this.selectedFilters.some(element => { return value === element })) {
                        return "active"
                    } else {
                        const filter = this.$store.getters.getAvailableOptions[this.filter.name];
                        if (filter) {
                            return filter.some(filterValue => {
                                if(filterValue === value) {
                                    return true
                                }
                            }) ? '': "inactive"
                        }
                    }
                } else if (value === '') {
                    return "active"
                }
            }
        }
    }
</script>
